<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="copy"></a><a id="page_vi"></a>Copyright © 2008 Fordham University Press</p>
<p class="copyright">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.</p>
<p class="copyright"><em>Dis-Enclosure</em> was originally published in French as Jean-Luc Nancy, <em>La déclosion (Déconstruction du christianisme, 1),</em> <em>©</em> 2005, Éditions Galilée.</p>
<p class="copyright">This work has been published with the assistance of the National Center for the Book—French Ministry of Culture.</p>
<p class="copyright">Ouvrage publié avec le concours du Ministère français chargé de la culture—Centre<br/>National du Livre.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data is available.</p>
<p class="copyright">Printed in the United States of America<br/>10 09 08     5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?d3b73b4e